// The public tool count, from ONE source (toolCount.json). Change it there; run
// marketing/scripts/check_tool_count.py --verify for the text homes that cannot import it.
import data from './toolCount.json';

export const TOOL_COUNT = data.toolCount;
